import { useRef, useEffect } from "react";
import { drawFrame } from "@/lib/animator";

const SAMPLE = [{
  id: 1, start: 0.15, end: 1.9, text: "Your Brand",
  words: [
    { word: "Your", start: 0.15, end: 0.85, word_id: "p1", segment_id: 1 },
    { word: "Brand", start: 0.9, end: 1.7, word_id: "p2", segment_id: 1 },
  ],
}];
const LOOP = 2.4;

// Lightweight looping preview that demonstrates a preset's font, colour,
// animation and position. Reuses the shared drawFrame renderer.
export default function BrandThumbnail({ config }) {
  const ref = useRef(null);
  useEffect(() => {
    const cv = ref.current;
    if (!cv) return;
    const ctx = cv.getContext("2d");
    const cfg = { ...config, emojiTriggers: [], fontSize: Math.min(config.fontSize || 90, 120) };
    let raf, start = performance.now(), last = 0;
    const draw = () => {
      const now = performance.now();
      if (now - last > 45) { // throttle ~22fps to stay light
        drawFrame(ctx, ((now - start) / 1000) % LOOP, cv.width, cv.height, SAMPLE, cfg);
        last = now;
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, [config]);
  return <canvas ref={ref} width={72} height={128} className="h-full w-full rounded-md bg-[#0A0A0A]" />;
}
